

import { SlideToggle } from 'react-smooth-slide-toggle';
function App() {
  return (
    <div className="container">
      <h1>React smooth slide toggle</h1>
      <div className='flex'>
        <div className='box'>
        <SlideToggle trigger={<a className='trigger'>Trigger <span> easing:Linear, 700ms </span>  </a>}>
          <div className='inner'>
            <h2>Lorem Ipsum</h2>
            <p>Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo.</p>
          </div>
        </SlideToggle>
        </div>
        <div className='box'>
        <SlideToggle expanded={true} easing={'easeInQuad'} duration={1000} trigger={<a className='trigger'>Trigger <span> easing: easeInQuad, 1000ms, initail state :expanded </span> </a>}>
          <div className='inner'>
            <h2>Lorem Ipsum</h2>
            <p>Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo.</p>

          </div>
        </SlideToggle>       
        </div> 
      </div>
      <div className='flex'>
        <div className='box'>
      <div className='accordion'>
        <h1>Accordion</h1>
        <SlideToggle  duration={400} trigger={<a className='accordion-item'>Accordion item1 </a>}>  
         <p className='accordion-content'>Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo.</p>      
        </SlideToggle>  
        <SlideToggle  duration={400} trigger={<a className='accordion-item'>Accordion item2 </a>}>  
         <p className='accordion-content'>Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo.</p>      
        </SlideToggle>  
        <SlideToggle  duration={400} trigger={<a className='accordion-item'>Accordion item3 </a>}>  
         <p className='accordion-content'>Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo.</p>      
        </SlideToggle>  
        <SlideToggle  duration={400} trigger={<a className='accordion-item'>Accordion item4 </a>}>  
         <p className='accordion-content'>Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo.</p>      
        </SlideToggle>  
      </div>
      </div>
      <div className='box pad15'>
      <h2>Read more example</h2>
        <SlideToggle  easing={'easeInQuad'} duration={200} trigger={<a className='read'>Read </a>}>
        <p>Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo.</p>
        </SlideToggle>
        </div>
</div>

 
      
     

    </div>
  );
}

export default App;
